module.exports = __webpack_public_path__ + "static/media/Privacy-6.e0dc71c9.png";